<template>
  <div ref="editorContainer" class="editor-container">
    <div ref="editor"></div>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-decoupled-document";

export default {
  name: "BasicCkeditor",
  props: {
    value: {
      required: true,
      default: "",
    },
  },
  data() {
    return {
      instance: null,
    };
  },
  mounted() {
    ClassicEditor.create(this.$refs.editor, {
      simpleUpload: {
        uploadUrl: "http://localhost:8000",
      },
    }).then((editor) => {
      this.instance = editor;

      if (this.$attrs.disabled == true) {
        editor.isReadOnly = true; // Disable CKEditor
        editor.editing.view.change((writer) => {
          writer.setStyle(
            "background-color",
            "#eceeef", // Set background color to grey
            editor.editing.view.document.getRoot()
          );
        });
      }
      
      if (this.value == null) {
        editor.setData("");
      } else {
        editor.setData(this.value);
      }

      this.adjustHeight(editor); // Adjust height right after load

      editor.model.document.on("change", () => {
        this.updateValue(editor.getData());
        this.adjustHeight(editor); // Adjust height on changes
      });
    });
  },
  watch: {
    value(newValue) {
      if (this.instance && newValue !== this.instance.getData()) {
        this.instance.setData(newValue);
      }
    },
  },
  methods: {
    updateValue(value) {
      this.$emit("input", value);
    },
    adjustHeight(editor) {
      const editorContainer = this.$refs.editorContainer;

      if (editorContainer) {
        const editorContent = editorContainer.querySelector(".ck-content");

        if (editorContent) {
          editorContainer.style.height = editorContent.scrollHeight + "px"; // Set container height
        }
      }
    },
  },
};
</script>

<style>
.editor-container {
  overflow: hidden; /* Ensures smooth transitions */
  resize: none; /* Prevents manual resizing */
}
.editor-container[disabled="disabled"] {
  background-color: #eceeef;
  cursor: not-allowed;
}
</style>
